<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="element-box">
        <h6 class="element-header">
          {{ $t('time_management.title') }}
        </h6>

        <div class="row" v-if="isApproved">
          <div class="col-12 text-center">
            <h5 style="color: #07bc0c">{{ $t('time_management.approved_month_message') }}</h5>
          </div>
        </div>

        <div class="row" v-else-if="isMonthLocked">
          <div class="col-12 text-center">
            <h5 style="color: red">{{ $t('time_management.locked_month_message') }}</h5>
          </div>
        </div>

        <h5 class="mb-4 mt-2">{{ userData?.firstName + ' ' + userData?.lastName }}</h5>

        <div class="row justify-content-between align-items-center mb-4">
          <div class="col-12 col-lg-5 mb-3 mb-lg-0">
            <div class="d-flex flex-wrap align-items-center" style="gap: 10px;">
              <SelectVue
                  v-model="year"
                  :options="userData.years"
                  classFormGroup="mb-0"
                  inputStyle="min-width: 100px"/>
              <SelectVue
                  v-model="month"
                  :options="enums.monthsInYear"
                  classFormGroup="mb-0"
                  inputStyle="min-width: 120px"/>
              <SearchButton
                  :label="$t('general.button.search')"
                  :loading="!isSearching"
                  @click="getTimeManagementList(true)"/>
            </div>
          </div>

          <div class="col-12 col-lg-7">
            <div class="d-flex flex-wrap justify-content-start justify-content-lg-end align-items-center" style="gap: 10px;">
              <div class="flex-grow-1 flex-sm-grow-0">
                <button class="btn btn-primary w-100"
                        @click="router.push({ name: 'overview', params: { id: overviewUserId } });">
                  Übersicht
                </button>
              </div>

              <!-- Excel Export -->
              <div v-if="isApproved" class="flex-grow-1 flex-sm-grow-0">
                <ExcelExportButton
                    :label="$t('general.excel_export')"
                    :loading="isExcelLoaded"
                    @click="getExcelExport"/>
              </div>
              <div v-if="currentUserRole !== 'ROLE_COACH' && currentUserRole !== 'ROLE_THERAPIST'" class="flex-grow-1 flex-sm-grow-0">
                <button v-if="isAdminOrHr"
                        class="btn btn-primary w-100"
                        @click="router.push({ name: 'monthlyOverview' });">
                  Zurück zur Übersicht
                </button>
                <button v-else
                        class="btn btn-primary w-100"
                        @click="router.push({ name: 'monthlyOverviewCoordinator' });">
                  Zurück zur Übersicht
                </button>
              </div>

            </div>
          </div>
        </div>

        <div class="table-content mb-5">
          <table class="table table-borded table-responsive" style="overflow-x: auto;">
            <thead>
            <tr>
              <th style="min-width: 90px; width: 4%" class="text-center">{{ $t('general.actions') }}</th>
              <th style="min-width: 120px; width: 9%">Datum</th>
              <th style="min-width: 100px; width: 6%">Tag</th>
              <th style="min-width: 120px; width: 12%">Art</th>
              <th style="min-width: 110px; width: 8%">Start</th>
              <th style="min-width: 110px; width: 8%">Ende</th>
              <th style="min-width: 110px; width: 8%">Pausenbeginn</th>
              <th style="min-width: 110px; width: 8%">Pausendauer</th>
              <th style="min-width: 90px; width: 7%">Arbeitszeit</th>
              <th style="min-width: 90px; width: 7%">Soll</th>
              <th style="min-width: 90px; width: 7%">Überstunden</th>
              <th style="min-width: 200px; width: 16%">Bemerkung</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in timeManagementList" :key="index"
                :style="{ borderBottom: `2px solid ${item?.workingDay?.color || 'transparent'}`,
                backgroundColor: `${hexToRgba(item?.workingDay?.color, 0.1)}` }">
              <td class="border-0 d-flex">
<!--                <button-->
<!--                    v-if="!overviewUserId && !isEditButtonHidden(item)"-->
<!--                    class="btn btn-outline-primary"-->
<!--                    @click="handleEditModal(item)">-->
<!--                  <i class="os-icon os-icon-edit"></i>-->
<!--                </button>-->
<!--                <button v-if="isAdminOrHr && !isDeleteButtonHidden(item)"-->
<!--                        class="btn btn-outline-danger ms-2"-->
<!--                        @click="handleDeleteModal(item)">-->
<!--                  <i class="os-icon os-icon-trash"></i>-->
<!--                </button>-->
              </td>
              <td class="border-0" :style="{ color: `${item?.workingDay?.color ?? 'black'}` }">
                {{ item.date }}
              </td>
              <td class="border-0" :style="{ color: `${item?.workingDay?.color ?? 'black'}` }">
                {{ item.dayName }}
              </td>
              <td class="border-0">{{ item.selectedWorkingDayDefinitionTranslation }}</td>
              <td class="border-0">{{ item.startTime }}</td>
              <td class="border-0">{{ item.endTime }}</td>
              <td class="border-0">{{ item.pauseStart }}</td>
              <td class="border-0">{{ item.pauseDuration }}</td>
              <td class="border-0">
                <span v-if="item.selectedWorkingDayDefinition === 'overtime_reduction'">- </span>
                {{ item.workingHours }}
              </td>
              <td class="border-0">{{ item.planedHours }}</td>
              <td class="border-0">{{ item.overtime }}</td>
              <td class="border-0 ">
                <div class="popover-custom" v-if="item.comment">
                  <div class="popover-content position-left">
                    {{ item.comment }}
                  </div>
                  <div class="border-bottom border-primary">
                    {{ truncateText(item.comment, 20) }}
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <Modal
            v-model="showEditModal"
            :title="t('course.private_coaching.module.create_goal')"
            :hide-cancel="true"
            :on-save="() => submitForm()" :sizeModal="'modal-lg'"
            classFooter="justify-content-center">
          <h6>{{ timeManagementItem.date + ' ' + timeManagementItem.dayName }}</h6>
          <div class="row mt-3">
            <div class="col-4">
              <SelectVue v-model="formData.workingDayDefinition"
                         :options="timeManagementItem.workingDayDefinition"
                         :required="true" :label="'Art'"
                         :validation="v$.workingDayDefinition"
                         :messages="v$.workingDayDefinition.required.$message"/>
            </div>
          </div>
          <div class="row">
            <div class="col-auto">
              <Timepicker v-model="formData.startTime" :required="true"
                          :disabled="formData.workingDayDefinition === 'professional_school'"
                          label="Start"/>
            </div>
            <div class="col-auto">
              <Timepicker v-model="formData.endTime" :required="true"
                          :disabled="formData.workingDayDefinition === 'professional_school'"
                          label="Ende"/>
            </div>
            <div class="col-auto">
              <Timepicker v-model="formData.pauseStart" :required="true"
                          :minutesArray='["00", "15", "30", "45"]'
                          :disabled="formData.workingDayDefinition === 'professional_school'"
                          label="Pausenbeginn"/>
            </div>
            <div class="col-auto">
              <Timepicker v-model="formData.pauseDuration" :required="true"
                          :minutesArray='["00", "15", "30", "45"]'
                          :disabled="formData.workingDayDefinition === 'professional_school'"
                          label="Pausendauer"/>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-auto text-end">
              <p class="mb-2 text-primary border-bottom">Arbeitszeit</p>
              <div>{{ calculateTimeDifference(formData.startTime, formData.endTime, formData.pauseDuration) }}</div>
            </div>
            <div class="col-auto text-end">
              <p class="mb-2 text-primary border-bottom">Soll</p>
              <div>{{ formData.planedHours }}</div>
            </div>
            <div class="col-auto text-end">
              <p class="mb-2 text-primary border-bottom">Überstunden</p>
              <div>
                {{
                  calculateOvertime(formData.planedHours, formData.startTime, formData.endTime, formData.pauseDuration)
                }}
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <BaseInput v-model="formData.comment" label="Bemerkung"/>
            </div>
          </div>
        </Modal>

        <!-- TOTALS FOR MONTH -->
        <div class="row justify-content-end">
          <h5 class="me-3 mb-0">Gesamt</h5>
          <div class="col-1 text-end" style="min-width: 110px;">
            <p class="border-bottom text-primary mb-2">Arbeitszeit</p>
            <div>{{ timeManagementTotal.workedHours }}</div>
          </div>
          <div class="col-1 text-end" style="min-width: 110px;">
            <p class="border-bottom text-primary mb-2">Soll Stunden</p>
            <div>{{ timeManagementTotal.planedHours }}</div>
          </div>
        </div>
        <div class="row justify-content-end mt-2" style="flex-wrap: nowrap;">
          <div>
            <p class="border-bottom text-primary mb-0">Überstunden stand heute:</p>
          </div>
          <div class="col-1 d-none d-sm-block" style="min-width: 110px;"></div>
          <div class="col-1 text-end" style="min-width: 110px;">
            <div>{{ timeManagementTotal.overtimeHoursTillLastWorkedDay }}</div>
          </div>
        </div>
        <div class="row justify-content-end mt-2" style="flex-wrap: nowrap;">
          <div>
            <p class="border-bottom text-primary mb-0">Offene Überstunden, laufender Monat:</p>
          </div>
          <div class="col-1 d-none d-sm-block" style="min-width: 110px;"></div>
          <div class="col-1 text-end" style="min-width: 110px;">
            <div>{{ timeManagementTotal.overworkedHours }}</div>
          </div>
        </div>
        <div class="row justify-content-end mt-2" style="flex-wrap: nowrap;">
          <div>
            <p class="border-bottom text-primary mb-2">
              Verfügbare Überstunden aus Vormonaten * :
              nach Ablauf des Monats werden die laufenden Monatsüberstunden inkludiert
            </p>
          </div>
          <div class="col-1 d-none d-sm-block" style="min-width: 110px;"></div>
          <div class="col-1 text-end" style="min-width: 110px;">
            <div>{{ timeManagementTotal.retroactiveOvertimeHours }}</div>
          </div>
        </div>
        <hr/>

<!--        <div class="row justify-content-end mt-4">-->
<!--          <div class="col-auto d-flex">-->
<!--            <button class="btn btn-primary" v-if="!isMonthLocked && !overviewUserId" @click="handleInformHrModal">-->
<!--              {{ $t('time_management.inform_hr') }}-->
<!--            </button>-->
<!--          </div>-->
<!--        </div>-->

        <ModalConfirm
            v-model="showInformHrModal"
            :header="'An HR abschicken'"
            :confirmationQuestion="'Sind Sie sicher, dass Sie die Personalabteilung informieren möchten?'"
            :onConfirm="informHr"/>

        <ModalDelete
            v-model="showDeleteModal"
            :header="t('general.delete_item_header')"
            :onDelete="deleteTimeManagement"/>
      </div>
    </div>
  </PageTemplate>
</template>


<script setup>
import {timeManagementService} from '@/api/TImeManagement';
import BaseInput from '@/components/base/BaseInput.vue';
import ExcelExportButton from '@/components/ExcelExportButton.vue';
import SearchButton from '@/components/button/SearchButton.vue';
import Loader from '@/components/Loader.vue';
import Modal from '@/components/modal/Modal.vue';
import ModalConfirm from '@/components/modal/ModalConfirm.vue';
import ModalDelete from '@/components/modal/ModalDelete.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Timepicker from '@/components/picker/Timepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import router from '@/router';
import {calculateOvertime, calculateTimeDifference, downloadFile, hexToRgba, truncateText} from '@/shared/functions';
import {requiredRule} from '@/shared/validators/validationRules';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import {piniaUserStore} from '@/store/piniaUserStore';
import useVuelidate from '@vuelidate/core';
import moment from 'moment';
import {computed, onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute} from 'vue-router';

const {enums} = piniaEnumsStore();
const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const currentUserRole = piniaCurrentUser.value.roles[0];
const allowedRolesForActions = ['ROLE_ADMIN', 'ROLE_PERSONAL', 'ROLE_HEAD_OF_HR'];

const isAdminOrHr = computed(() =>
    allowedRolesForActions.some(role => piniaCurrentUser.value.roles.includes(role)),
);

const {t} = useI18n();
const route = useRoute();
const isLoaded = ref(false);
const isSearching = ref(false);
const isExcelLoaded = ref(false);
const isMonthLocked = ref(false);
const overviewUserId = route.params.id;
const timeManagementList = ref([]);
const timeManagementItem = ref([]);
const timeManagementTotal = ref([]);
const isApproved = ref(false);
const showDeleteModal = ref(false);
const showEditModal = ref(false);
const showInformHrModal = ref(false);
const isSubmitting = ref(false);

const year = ref(moment(new Date()).year());
const month = ref(moment(new Date()).month() + 1);

const dataForInformHr = ref({
  year: ref(moment(new Date()).year()),
  month: ref(moment(new Date()).month() + 1),
});

let yearQueryParam = route.query.year;
let monthQueryParam = route.query.month;

if (yearQueryParam) {
  year.value = +yearQueryParam;
  dataForInformHr.value.year = +yearQueryParam;
}
if (monthQueryParam) {
  month.value = +monthQueryParam;
  dataForInformHr.value.month = +monthQueryParam;
}

const userData = ref({
  years: [],
});

const formData = ref({
  startTime: '00:00',
  endTime: '00:00',
  workingDayDefinition: '',
  pauseStart: '00:00',
  pauseDuration: '00:00',
  comment: '',
});

const rules = ref({
  workingDayDefinition: requiredRule(t),
});

const computedRules = computed(() => rules.value);
const v$ = useVuelidate(computedRules, formData);

const submitForm = async () => {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  const data = {
    ...formData.value,
    workingHours: calculateTimeDifference(
        formData.value.startTime,
        formData.value.endTime,
        formData.value.pauseDuration,
    ),
  };

  try {
    await timeManagementService.postSave(data);
    await getTimeManagementList();
    showEditModal.value = false;

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
};

async function getExcelExport() {
  await downloadFile(
      `/time-management/data-for-month-excel-export/${year.value}/${month.value}/${overviewUserId}`,
      undefined, undefined, false, 'GET', isExcelLoaded)
}

async function getTimeManagementList(searching) {
  try {

    if (searching === true) {
      isSearching.value = false;
      dataForInformHr.value.year = year.value;
      dataForInformHr.value.month = month.value;
    }

    const {data} = await timeManagementService.getDataForMonth(
        year.value, month.value, overviewUserId,
    );
    timeManagementList.value = data.data.monthData;

    const overviewUserData = data.data.userData;
    userData.value = {
      ...overviewUserData,
      years: overviewUserData.years.map((item) => ({
        label: item,
        value: item,
      })),
    };

    const {data: totalData} = await timeManagementService.getTotalForMonth(
        year.value, month.value, overviewUserId,
    );
    timeManagementTotal.value = totalData.data;
    isApproved.value = totalData.data?.approved;
    isSearching.value = true;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = true;
  }
}

function handleEditModal(item) {
  CloseToast();
  timeManagementItem.value = item;
  formData.value = {
    ...item,
    startTime: item.startTime || '00:00',
    endTime: item.endTime || '00:00',
    pauseStart: item.pauseStart || '00:00',
    pauseDuration: item.pauseDuration || '00:00',
    workingDay: item.workingDay.value,
    workingDayDefinition: item.workingDayDefinition.find(item => item.selected)?.value ?? item.workingDayDefinition[0]?.value,
  };
  showEditModal.value = true;
  showDeleteModal.value = false;
  showInformHrModal.value = false;
}

function isEditButtonHidden(item) {
  const hiddenKeys = ['ill', 'vacation', 'special_leave', 'parental_leave'];
  const isTypeHidden = hiddenKeys.includes(item?.selectedWorkingDayDefinition);
  const isLocked = item?.isLocked;
  isMonthLocked.value = item?.isLocked;

  return isTypeHidden || isLocked;
}

function handleDeleteModal(item) {
  CloseToast();
  timeManagementItem.value = item;
  showDeleteModal.value = true;
  showEditModal.value = false;
}

async function deleteTimeManagement() {
  try {
    await timeManagementService.delete(timeManagementItem.value.id);
    await getTimeManagementList();

    showDeleteModal.value = false;
    showEditModal.value = false;
    SuccessToast(t('general.toasts.delete_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

function isDeleteButtonHidden(item) {
  return item.isLocked ||
      !item.id ||
      item.selectedWorkingDayDefinition === 'vacation' ||
      item.selectedWorkingDayDefinition === 'special_leave' ||
      item.selectedWorkingDayDefinition === 'parental_leave' ||
      item.selectedWorkingDayDefinition === 'ill';
}

function handleInformHrModal() {
  CloseToast();
  showInformHrModal.value = true;
  showDeleteModal.value = false;
  showEditModal.value = false;
}

async function informHr() {
  try {
    await timeManagementService.informHr(dataForInformHr.value.year, dataForInformHr.value.month);
    await getTimeManagementList();

    showInformHrModal.value = false;
    showDeleteModal.value = false;
    showEditModal.value = false;
    SuccessToast(t('general.toasts.delete_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  CloseToast();
  await getTimeManagementList();
  isLoaded.value = true;
});
</script>